import _get from 'lodash/get';
import { fetcher } from '../../../utility/domUtils';

export const CREATE_DEFAULT_BUTTON = 'CREATE_DEFAULT_BUTTON';
export const CREATE_DEFAULT_BUTTON_SUCCESS = 'CREATE_DEFAULT_BUTTON_SUCCESS';
export const CREATE_DEFAULT_BUTTON_ERROR = 'CREATE_DEFAULT_BUTTON_ERROR';
export const DELETE_BUTTON = 'DELETE_BUTTON';
export const DELETE_BUTTON_SUCCESS = 'DELETE_BUTTON_SUCCESS';
export const DELETE_BUTTON_ERROR = 'DELETE_BUTTON_ERROR';
export const GET_BUTTON = 'GET_BUTTON';
export const GET_BUTTON_SUCCESS = 'GET_BUTTON_SUCCESS';
export const GET_BUTTON_ERROR = 'GET_BUTTON_ERROR';
export const UPDATE_VOUCHER_LISTING_STATUS = 'UPDATE_VOUCHER_LISTING_STATUS';
export const UPDATE_VOUCHER_LISTING_STATUS_SUCCESS =
  'UPDATE_VOUCHER_LISTING_STATUS_SUCCESS';
export const UPDATE_VOUCHER_LISTING_STATUS_ERROR =
  'UPDATE_VOUCHER_LISTING_STATUS_ERROR';

export function deleteButton(buttonId, offerProgramId) {
  return (dispatch, getState) => {
    dispatch({
      type: DELETE_BUTTON,
    });

    let fetchURL = `/donate/api/buttons/${buttonId}`;

    // if we have offerProgramId then append into the URL
    if (offerProgramId) {
      fetchURL = `${fetchURL}/${offerProgramId}`;
    }

    let resParams = {};
    return fetcher(fetchURL, {
      method: 'DELETE',
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: DELETE_BUTTON_ERROR,
            payload: {
              error,
            },
          });
          return error;
        }
        dispatch({
          type: DELETE_BUTTON_SUCCESS,
          payload: responseJson,
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: DELETE_BUTTON_ERROR,
          payload: {
            error,
          },
        });
        return error;
      });
  };
}

export function getButton(id) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_BUTTON,
    });

    let resParams = {};
    return fetcher(`/donate/api/buttons/${id}`, {
      method: 'GET',
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: GET_BUTTON_ERROR,
            payload: { error },
          });

          return error;
        }
        const button = _get(responseJson, 'button');

        dispatch({
          type: GET_BUTTON_SUCCESS,
          payload: button,
        });

        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: GET_BUTTON_ERROR,
          payload: { error },
        });

        return error;
      });
  };
}

export function updateVoucherListingStatus(isToList, button) {
  return (dispatch, getState) => {
    const payload = {
      isToList,
      button,
    };

    dispatch({
      type: UPDATE_VOUCHER_LISTING_STATUS,
    });

    let resParams = {};
    return fetcher(`/donate/api/voucher_variant/${button.voucherVariant.id}`, {
      method: 'PUT',
      body: JSON.stringify({
        payload,
      }),
    })
      .then((response) => {
        resParams = {
          ...resParams,
          status: response.status,
          statusText: response.statusText,
          ok: response.ok,
        };
        return response.json();
      })
      .then((responseJson) => {
        if (!resParams.ok) {
          const error = {
            responseJSON: responseJson,
            ...resParams,
          };
          dispatch({
            type: UPDATE_VOUCHER_LISTING_STATUS_ERROR,
            payload: { error },
          });
          return error;
        }
        dispatch({
          type: UPDATE_VOUCHER_LISTING_STATUS_SUCCESS,
          payload: responseJson,
        });
        return { ...responseJson, ok: resParams.ok };
      })
      .catch((error) => {
        dispatch({
          type: UPDATE_VOUCHER_LISTING_STATUS_ERROR,
          payload: { error },
        });

        return error;
      });
  };
}
